import React from 'react';

export default function Box(props) {
    return (
        <div style={{...styles.container, ...props.style}}>
            {props.children}
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#FFFFFF1A',
        borderRadius: '16px',
        boxShadow: '0px 4px 24px 1px #00000040',
        padding: 8,
        maxWidth: '1200px'
    }
};